var map = {
	"./10_nuts.png": 2510,
	"./1drink_12beer.png": 2511,
	"./1serving_8ounces.png": 2512,
	"./1serving_8ounces2.png": 2513,
	"./1serving_8ounces3.png": 2514,
	"./1serving_8ounces4.png": 2515,
	"./1serving_8ounces5.png": 2516,
	"./8ounces_1glass.png": 2517,
	"./can_1.png": 2518,
	"./can_2.png": 2519,
	"./can_3.png": 2520,
	"./cup.png": 2521,
	"./dried_serving_1/4cup.png": 2522,
	"./dried_serving_1:4cup.png": 2523,
	"./fresh_serving_1cup.png": 2524,
	"./glass_1.png": 2525,
	"./glass_2.png": 2526,
	"./golfball.png": 2527,
	"./halfthumb.png": 2528,
	"./hand_1.png": 2529,
	"./hand_2.png": 2530,
	"./hand_3.png": 2531,
	"./hand_4.png": 2532,
	"./hand_5.png": 2533,
	"./how.png": 864,
	"./serving_1/2cup.png": 2534,
	"./serving_1:2cup.png": 2535,
	"./serving_1tbsp.png": 2536,
	"./serving_3/4ounces.png": 2537,
	"./serving_3:4ounces.png": 2538,
	"./thumbx2.png": 2539,
	"./usda.png": 2540,
	"./vegetables_1cup.png": 2541,
	"./what.png": 862,
	"./wholethumb.png": 2542,
	"./why.png": 863
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2509;